module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-UltraLightIt.cdcd5979.woff";